import { SxStyleProp } from 'theme-ui';

export const Divisor: SxStyleProp = {
  display: ['none', 'block'],
  width: '90%',
  maxWidht: '1472px',
  border: '1px solid #E5E5E5',
};
